import CheckoutBill from "./checkoutBill";
import CheckoutForm from "./checkoutForm";

// Component checkout
const Checkout = () => {
  return (
    <section className="Co_section">
      <h4 className="text-success ms-5">Thông tin giao hàng</h4>
      <div className="row Co_section_flex">
        <div className="col-12 col-md-8 col-lg-9 Co_form">
          <CheckoutForm />
        </div>

        <div className="col-12 col-md-4 col-lg-3 Co_bill">
          <CheckoutBill />
        </div>
      </div>
    </section>
  );
};

export default Checkout;
